// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2fi29","head":"ProcedureTableInfo_head__2eWRo"};